module.exports = __webpack_public_path__ + "img/thumbnail_WildWaterBuffalo_m_albino.566f1a07.png";